// extracted by mini-css-extract-plugin
export var sort = "FilterSelect-module--sort--J7Zgg";
export var sortIcon = "FilterSelect-module--sortIcon--7hg2X";
export var sortSelect = "FilterSelect-module--sortSelect--3zgTb";